import { render, staticRenderFns } from "./AllChatRooms.vue?vue&type=template&id=3d64fa9d&scoped=true&"
import script from "./AllChatRooms.vue?vue&type=script&lang=js&"
export * from "./AllChatRooms.vue?vue&type=script&lang=js&"
import style0 from "./AllChatRooms.vue?vue&type=style&index=0&id=3d64fa9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d64fa9d",
  null
  
)

export default component.exports